import { useTranslation } from "react-i18next";
import { Dialog } from "primereact/dialog";

import { ChecklistsModalProps } from "../../../models/pages/checklists/checklists-modal";
import ChecklistsList from "./ChecklistsList";

const ChecklistsModal = (props: ChecklistsModalProps) => {
	const { t } = useTranslation("common");

	return (
		<Dialog
			header={
				<div className="dialog-custom-header">
					{/* Title */}
					<span className="dialog-custom-header__title">
						{t("PARTICIPANT.DASHBOARD.CHECKLISTS.MODAL.TITLE")}
					</span>
				</div>
			}
			visible={props.isVisible}
			className="medications-modal"
			breakpoints={{ "960px": "80vw", "641px": "100vw" }}
			style={{ width: "80vw" }}
			modal={true}
			focusOnShow={false}
			draggable={false}
			onHide={props.closeModal}
		>
			<ChecklistsList checklists={props.checkLists} />
		</Dialog>
	);
};

export default ChecklistsModal;
